<template>
  <div>
    <div class="px-2">
      <div style="display: flex">
        <div style="width: 16%" class="pr-2">
          <v-card>
            <div style="background-color: #eee" class="text-xs-center pa-1">Answered</div>
            <v-divider></v-divider>
            <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
              {{ dataByStatus.answered ? numberWithCommas(dataByStatus.answered) : 0 }}
            </div>
          </v-card>
        </div>
        <div style="width: 16%" class="pr-2">
          <v-card>
            <div style="background-color: #eee" class="text-xs-center pa-1">Pending</div>
            <v-divider></v-divider>
            <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
              {{ dataByStatus.pending ? numberWithCommas(dataByStatus.pending) : 0 }}
            </div>
          </v-card>
        </div>
        <div style="width: 16%" class="pr-2">
          <v-card>
            <div style="background-color: #eee" class="text-xs-center pa-1">Close</div>
            <v-divider></v-divider>
            <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
              {{ dataByStatus.closed ? numberWithCommas(dataByStatus.closed) : 0 }}
            </div>
          </v-card>
        </div>
        <div style="width: 16%" class="pr-2">
          <v-card>
            <div style="background-color: #eee" class="text-xs-center pa-1">Cancelled</div>
            <v-divider></v-divider>
            <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
              {{ dataByStatus.cancelled ? numberWithCommas(dataByStatus.cancelled) : 0 }}
            </div>
          </v-card>
        </div>
        <div style="width: 20%" class="pr-2">
          <v-card>
            <div style="background-color: #eee" class="text-xs-center pa-1">
              Cancelled By Customer
            </div>
            <v-divider></v-divider>
            <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
              {{
                dataByStatus.cancelled_by_customer
                  ? numberWithCommas(dataByStatus.cancelled_by_customer)
                  : 0
              }}
            </div>
          </v-card>
        </div>
        <div style="width: 16%" class="pr-2">
          <v-card>
            <div style="background-color: #eee" class="text-xs-center pa-1">Cold case</div>
            <v-divider></v-divider>
            <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
              {{ dataByStatus.cold_case ? numberWithCommas(dataByStatus.cold_case) : 0 }}
            </div>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      dataByStatus: this.value
    }
  },
  computed: {},
  methods: {
    numberWithCommas(x) {
      x = x.toString()
      const pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/Summary.vue